import { Emoji } from 'emoji-picker-react';
import { eLeadStatus } from '../../../providers/SocketsProvider/Sockets.enums';
import { tStatusEmojiProps } from '../AdvanceSearchModal.types';

export default function StatusEmoji(props: tStatusEmojiProps) {
  const { status } = props;
  switch (status) {
    case eLeadStatus.IMPORTANT:
      return <Emoji unified="2b50" size={18} />;
    case eLeadStatus.PENDING:
      return <Emoji unified="23f3" size={18} />;
    case eLeadStatus.STUCK:
      return <Emoji unified="1f9ca" size={18} />;
    case eLeadStatus.URGENT:
      return <Emoji unified="1f525" size={18} />;
    default:
      return null;
  }
}
